import React from 'react';
import PropTypes from 'prop-types';
import styles from './Bars.module.scss';

export const HBar = ({ label, bgColor = '#404040' }) => {
  return (
    <div className={styles.hBarContainer}>
      {label && <span className={styles.label}>{label}</span>}
      <div className={styles.line} style={{ backgroundColor: bgColor }} />
    </div>
  );
};

HBar.propTypes = {
  label: PropTypes.string,
  bgColor: PropTypes.string,
};

export default HBar;

